import api from '../../../services/Api'
import {ILaudoAuditoria, ILaudoUsuarioOpcao} from '../interfaces/ILaudoAuditoria'

// DEVN3-521 — o `periodo` é sempre o id da esteira (mesmo valor do combo "Período" da tela).

export const LaudoAuditoriaService = {
  async garantir(periodo: string): Promise<ILaudoAuditoria> {
    const {data} = await api.post<ILaudoAuditoria>('laudo-auditoria/garantir', {periodo})
    return data
  },

  async buscar(periodo: string): Promise<ILaudoAuditoria | null> {
    const resp = await api.get<ILaudoAuditoria>('laudo-auditoria', {params: {periodo}})
    // 204 => corpo vazio (laudo ainda não existe).
    return resp.status === 204 || !resp.data ? null : resp.data
  },

  // Usuários ativos do cliente, para as listas de responsáveis do laudo.
  async listarUsuarios(): Promise<ILaudoUsuarioOpcao[]> {
    const {data} = await api.get<ILaudoUsuarioOpcao[]>('laudo-auditoria/usuarios')
    return data
  },

  async salvarResponsaveis(
    periodo: string,
    responsaveis: {
      responsavelTecnicoId: number
      elaboradorId: number
      revisorId: number
      aprovadorId: number
    }
  ): Promise<ILaudoAuditoria> {
    const {data} = await api.put<ILaudoAuditoria>('laudo-auditoria/responsaveis', {
      periodo,
      ...responsaveis,
    })
    return data
  },

  async editarCapitulo(
    id: number,
    textos: {abertura?: string; leituraTecnica?: string; fechamento?: string}
  ): Promise<void> {
    await api.put(`laudo-auditoria/capitulo/${id}`, textos)
  },

  async salvarRascunho(
    id: number,
    textos: {abertura?: string; leituraTecnica?: string; fechamento?: string}
  ): Promise<void> {
    await api.post(`laudo-auditoria/capitulo/${id}/rascunho`, textos)
  },

  async rejeitar(id: number): Promise<void> {
    await api.post(`laudo-auditoria/capitulo/${id}/rejeitar`)
  },

  async regenerar(
    id: number,
    body: {refinamento?: string; modo?: 'MAIS_OBJETIVO' | 'MAIS_TECNICO'}
  ): Promise<void> {
    await api.post(`laudo-auditoria/capitulo/${id}/regenerar`, body)
  },

  // "Aceitar" da revisão: o capítulo aceito entra no PDF.
  async aprovar(id: number): Promise<ILaudoAuditoria> {
    const {data} = await api.post<ILaudoAuditoria>(`laudo-auditoria/capitulo/${id}/aprovar`)
    return data
  },

  async exportar(
    periodo: string,
    formato: 'PDF' | 'DOCX' = 'PDF'
  ): Promise<{arquivoRetornoId: number; operacaoId: number}> {
    const {data} = await api.post<{arquivoRetornoId: number; operacaoId: number}>(
      'laudo-auditoria/exportar',
      {periodo, formato}
    )
    return data
  },
}
